interface FormatFlocktoryUserEmailParams {
  email?: string | null;
  phone?: string | null;
  userId?: number | null;
}

export const formatFlocktoryUserEmail = ({
  email,
  phone,
  userId
}: FormatFlocktoryUserEmailParams): string | null => {
  const normalizedEmail = email?.trim();

  if (normalizedEmail) {
    return normalizedEmail;
  }

  if (phone) {
    const digits = phone.replace(/\D/g, '');

    if (digits) {
      return `${digits}@unknown.email`;
    }
  }

  if (userId) {
    return `${userId}@unknown.email`;
  }

  return null;
};
